require('./isClass');

var MODULE_NAME = 'ui.bootstrap.module.isClass';

angular.module(MODULE_NAME, ['ui.bootstrap.isClass']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/src/isClass/index.js
// module id = 632
// module chunks = 1